import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { FeedBackData } from '../../Interfaces/IDashBoard';
import { dashBoardConfig, defaultConfig } from '../../Themes/themeConfigLogin';
import MultipleChoiceQuestion from './MultipleChoiceQuestion';
import { makeStyles } from '@mui/styles';
import { Typography, useMediaQuery } from '@mui/material';
import { useState, useEffect } from 'react';

/**
 * updates the question response with value
 * @param value the input value/response of ques
 * @param indexParam the section index
 * @param indexMain the index of the question in that section
 * @param impPayload the payload
 * @param setImpPayload the state function to upload the payload
 */
const handleData = (value: any, indexParam: number, indexMain: number, impPayload: any, setImpPayload: any, setAvgScore: any, key?: string) => {
  const fieldKey = key ? key : 'questionResponse';
  if (impPayload && impPayload.length > indexMain && impPayload[indexMain]) {
    // console.log(value, indexParam, indexMain);
    const payloadCopy = [...impPayload];
    impPayload[indexMain].parameters[indexParam][fieldKey] = value;

    let totalScore = 0;

    payloadCopy.forEach((mainItem) => {
      mainItem.parameters.forEach((param: any) => {
        if (param.questionResponse !== undefined && param.questionResponse !== null && param.weightage !== 0) {
          if (/\d/.test(param.questionResponse)) {
            totalScore += (Number.parseFloat(param.questionResponse) * param.weightage) / 100;
          }
        }
      });
    });

    const avgScore = totalScore;
    const customPayload = payloadCopy?.filter((items: any) => {
      if (items?.sectionLabel === 'Notes') {
        return items?.parameters?.map((dataItems: any) => {
          delete dataItems['comments'];
          return dataItems;
        });
      }
      return items;
    });

    setImpPayload(customPayload);
    setAvgScore(avgScore.toFixed(2));
  }
};

const useStyles = makeStyles(() => ({
  reviewLabels: {
    borderRadius: '24px',
    fontSize: '14px',
    fontWeight: '500',
    padding: '8px 16px',
    cursor: 'pointer',
    border: 'none',
    '@media (max-width: 600px)': {
      fontSize: '12px',
    },
    '@media (min-width: 1920px)': {
      fontSize: '18px',
    },
  },
  questionLabel: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    color: '#333333',
    '@media (min-width: 1920px)': {
      fontSize: '18px !important',
    },
  },
  feedBackContainer: {
    padding: '24px 20px',
    border: '1px solid #E6E6E6',
    background: '#fff',
    borderRadius: '12px',
    // minHeight: '280px',
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 600px)': {
      padding: '20px 16px',
      minHeight: '260px',
    },
    '@media (min-width: 1920px)': {
      minHeight: '320px',
    },
  },
}));

interface FieldsDatas {
  type: FeedBackData;
  indexParam: number;
  indexMain: number;
  isMobilescreen: boolean;
  teamStrength: any;
  impPayload: any;
  setImpPayload: any;
  select: any;
  evaluted: boolean;
  setAvgScore: any;
}

const Fields: React.FunctionComponent<FieldsDatas> = ({ type, indexParam, indexMain, isMobilescreen, teamStrength, impPayload, setImpPayload, select, evaluted, setAvgScore }) => {
  const classes = useStyles();
  const isMaxScreen = useMediaQuery('(min-width:1920px)');

  const [ratingInputValue, setRatingInputValue] = useState<string>(type?.questionResponse?.toString() || '');
  const [ratingInputError, setRatingInputError] = useState<string>('');

  useEffect(() => {
    if (type?.questionResponse !== null && type?.questionResponse !== undefined) {
      setRatingInputValue(String(type.questionResponse));
    } else if (type?.questionType === 'Rating') {
      setRatingInputValue('');
    }
  }, [type?.questionResponse, type?.questionType]);

  const reviewLabels: any = {
    1: 'Very poor',
    2: 'Poor',
    3: 'Average',
    4: 'Good',
    5: 'Excellent',
  };

  const handleSingleSelect = (item: any, question: any, options?: any, section?: any) => {
    if (impPayload && impPayload.length > section && impPayload[section]) {
      var qNo = -1;
      impPayload[section]?.parameters?.map((ele: any, indx: any) => {
        if (ele.questionLabel === question) {
          qNo = indx;
        }
      });

      if (qNo > 0) {
        const payloadCopy = [...impPayload];
        impPayload[section].parameters[qNo].questionResponse = item;
        setImpPayload(payloadCopy);
      }
    }
  };

  switch (type.questionType) {
    case 'Rating':
      return (
        <Box component={'div'} gap={isMobilescreen ? '12px' : '24px'} className={`h-100 w-100 d-flex flex-column justify-content-between ${classes.feedBackContainer}`}>
          <Typography className={classes.questionLabel}>{type?.questionLabel}</Typography>

          {/* Rating buttons removed — replaced with number input below */}
          {/*
          <Box component={'div'} gap={'4px'} className={isMobilescreen ? 'd-flex flex-wrap w-100' : `d-flex flex-wrap justify-justify-flex-start w-100 scrollBar`}>
            {Array.from({ length: type?.maxGrade + 1 }, (_, index) => {
              const displayIndex = index;
              return (
                index !== 0 && (
                  <div key={displayIndex}>
                    <Box
                      component={'button'}
                      className={classes.reviewLabels}
                      color={teamStrength?.value === displayIndex || type?.questionResponse === displayIndex.toString() ? `#665097` : `#333333`}
                      bgcolor={teamStrength?.value === displayIndex || type?.questionResponse === displayIndex.toString() ? '#D9C8FF' : '#F6F8FB'}
                      onClick={() => {
                        !evaluted && handleData(displayIndex.toString(), indexParam, indexMain, impPayload, setImpPayload, setAvgScore);
                      }}
                    >
                      {`${displayIndex}. ${reviewLabels[displayIndex as any]}`}
                    </Box>
                  </div>
                )
              );
            })}
          </Box>
          */}

          <Box component={'div'}>
            <TextField
              type="text"
              inputProps={{ inputMode: 'decimal' }}
              value={ratingInputValue}
              disabled={evaluted}
              placeholder={`e.g. 1 – ${type?.maxGrade}`}
              size="small"
              error={!!ratingInputError}
              helperText={ratingInputError || `Max: ${type?.maxGrade}`}
              onChange={(e) => {
                const val = e.target.value;

                // Allow only digits and a single decimal point
                if (val !== '' && !/^\d*\.?\d*$/.test(val)) return;

                // Prevent typing more than 2 decimal places
                const parts = val.split('.');
                if (parts[1] !== undefined && parts[1].length > 2) return;

                setRatingInputValue(val);

                // Intermediate states — don't update payload yet
                if (val === '' || val.endsWith('.')) {
                  setRatingInputError('');
                  return;
                }

                const numVal = Number.parseFloat(val);

                if (numVal > type?.maxGrade) {
                  setRatingInputError(`Value cannot exceed ${type?.maxGrade}`);
                  return;
                }

                setRatingInputError('');
                handleData(val, indexParam, indexMain, impPayload, setImpPayload, setAvgScore);
              }}
              sx={{ width: '150px' }}
            />
          </Box>

          <Box
            onChange={(e: any) => {
              handleData(e.target.value, indexParam, indexMain, impPayload, setImpPayload, setAvgScore, 'comments');
            }}
            disabled={evaluted}
            value={type?.comments ?? ''}
            component={'textarea'}
            border={'1px solid #E6E6E6'}
            padding={'10px'}
            placeholder="Type your comments here..."
            height={isMaxScreen ? '112px' : '84px'}
            borderRadius={'8px'}
            sx={{ resize: 'none' }}
          />
        </Box>
      );
    case 'Yes/No':
      return (
        <Box 
          component={'div'} 
          padding={'24px 20px'} 
          border={` 1px solid ${dashBoardConfig.borderStyle2Default}`} 
          className="card h-100" 
          width={'100%'}
          sx={{
            minHeight: '280px',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '12px',
            '@media (max-width: 600px)': {
              minHeight: '260px',
            },
            '@media (min-width: 1920px)': {
              minHeight: '320px',
            },
          }}
        >
          <Box className={`${defaultConfig.primaryFont} mb-3`} sx={{ fontSize: '14px', fontWeight: '500', color: '#333333' }}>
            {type?.questionLabel}
          </Box>
          <Box component={'div'} sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Box component={'div'} className={isMobilescreen ? 'd-flex  w-100 mt-4' : 'd-flex justify-flex-start w-100 mt-4'}>
              <Box
                component={'button'}
                className={select?.value === 'Yes' || type?.questionResponse === 'Yes' ? defaultConfig.whiteFonts : defaultConfig.blackFonts}
                marginRight={'50px'}
                padding={'15px 20px'}
                border={dashBoardConfig.borderStyle2Default}
                borderRadius={'4px'}
                bgcolor={select?.value === 'Yes' || type?.questionResponse === 'Yes' ? defaultConfig.primaryColor : defaultConfig.tertiaryColor}
                onClick={() => {
                  !evaluted && handleData('Yes', indexParam, indexMain, impPayload, setImpPayload, setAvgScore);
                }}
              >
                {type?.questionResponse === 'Yes' ? <span>{type?.questionResponse}</span> : 'Yes'}
              </Box>
              <Box
                component={'button'}
                className={select?.value === 'No' || type?.questionResponse === 'No' ? defaultConfig.whiteFonts : defaultConfig.blackFonts}
                marginRight={'50px'}
                padding={'15px 20px'}
                border={dashBoardConfig.borderStyle2Default}
                borderRadius={'4px'}
                bgcolor={select?.value === 'No' || type?.questionResponse === 'No' ? defaultConfig.primaryColor : defaultConfig.tertiaryColor}
                onClick={() => {
                  !evaluted && handleData('No', indexParam, indexMain, impPayload, setImpPayload, setAvgScore);
                }}
              >
                {type?.questionResponse === 'No' ? <span>{type?.questionResponse}</span> : 'No'}
              </Box>
            </Box>
          </Box>
        </Box>
      );
    case 'Comment':
      return (
        <Box component={'div'} gap={'24px'} className={`h-100 w-100 d-flex flex-column justify-content-between ${classes.feedBackContainer}`}>
          <Typography className={classes.questionLabel}>{type?.questionLabel}</Typography>
          <Box
            component={'textarea'}
            border={'1px solid #E6E6E6'}
            height={'84px'}
            padding={'10px'}
            borderRadius={'8px'}
            sx={{ resize: 'none' }}
            disabled={evaluted}
            value={type?.questionResponse ?? ''}
            onChange={(e) => {
              !evaluted && handleData(e.target.value, indexParam, indexMain, impPayload, setImpPayload, setAvgScore);
            }}
          />
        </Box>
      );
    case 'Multiple Choice':
      return (
        <>
          {impPayload && (
            <MultipleChoiceQuestion
              question={type?.questionLabel}
              options={type?.mcqOptions.slice(0, -1).split(/;/) || null}
              isMobilescreen={isMobilescreen}
              handleSingleSelect={handleSingleSelect}
              selectedOption={type?.questionResponse || null}
              imPayload={impPayload}
              clickable={evaluted}
            ></MultipleChoiceQuestion>
          )}
        </>
      );
    default:
      return <></>;
  }
};

export default Fields;
